import { useAuth } from 'context/AuthProvider';
import React, { useState, useEffect } from 'react';
import { Badge, Button, Form, FormGroup, Input, Label, UncontrolledAlert } from 'reactstrap'
import { ApiSolicitudVacacionesService } from 'services/ApiSolicitudVacacionesService';
import { apiMotivoAusenciasService } from 'services/apiMotivoAusenciasService';
import { dateUtils } from "../../utils/dateUtils";
import { showAppAlert } from "components/common/AppAlerts";

const formatTwoDigits = (number) => (number < 10 ? `0${number}` : `${number}`);
const addDaysToISODate = (isoDate, daysToAdd) => {
  if (!isoDate || !Number.isInteger(daysToAdd)) return "";
  const [year, month, day] = isoDate.split("-").map(Number);
  if (!year || !month || !day) return "";
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + daysToAdd);
  return `${date.getFullYear()}-${formatTwoDigits(date.getMonth() + 1)}-${formatTwoDigits(date.getDate())}`;
};

const FormSolicitarVacaciones = () => {
  const { empleado } = useAuth();

     
  const [motivos, setMotivos] = useState([]);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [tipo, setTipo] = useState("VACACIONES");
  const [tramitado, setTramitado] = useState(false)
  const [isCalculatingFechaHasta, setIsCalculatingFechaHasta] = useState(false);
  const [motivoId, setMotivoId] = useState("");
  const [comentarioDetalle, setComentarioDetalle] = useState("");
  
  const motivoSeleccionado = motivos.find((motivo) => String(motivo.id) === String(motivoId));
  const diasPermitidosMotivo = motivoSeleccionado?.diasPermitidos || null;
  const tipoComputoDiasMotivo = motivoSeleccionado?.tipoComputoDias || "HABILES";
  const tipoComputoLabel = tipoComputoDiasMotivo === "NATURALES" ? "naturales" : "habiles";
  const hasDiasPermitidos = tipo === "AUSENCIA" && Number.isInteger(diasPermitidosMotivo) && diasPermitidosMotivo > 0;
  const usaDiasPermitidos = hasDiasPermitidos;
  const fechaHastaNaturalCalculada =
    usaDiasPermitidos && tipoComputoDiasMotivo === "NATURALES"
      ? addDaysToISODate(fechaInicio, diasPermitidosMotivo)
      : "";
 

  useEffect(() => {
    const fetchMotivos = async () => {
      try {
        const response = await apiMotivoAusenciasService.getAllByID(empleado.empresaId);
        const data = await response.json();
        setMotivos(data);
      } catch (error) {
        console.error("Error al obtener los motivos de ausencia:", error);
      }
    };

    if (tipo === 'AUSENCIA') {
      fetchMotivos();
    } else {
      setMotivoId("");
    }
  }, [tipo, empleado.empresaId]);

  useEffect(() => {
    if (!usaDiasPermitidos) {
      setIsCalculatingFechaHasta(false);
      return;
    }

    if (!fechaInicio || !motivoId || !empleado.id) {
      setIsCalculatingFechaHasta(false);
      setFechaFin("");
      return;
    }

    if (tipoComputoDiasMotivo === "NATURALES") {
      setIsCalculatingFechaHasta(false);
      setFechaFin(fechaHastaNaturalCalculada);
      return;
    }

    let cancelled = false;

    const calcularFechaHastaHabiles = async () => {
      try {
        setIsCalculatingFechaHasta(true);
        const payload = {
          solicitud: {
            fechaSolicitud: new Date().toISOString().slice(0, 10),
          },
          ausencia: {
            empleadoId: Number(empleado.id),
            fechaDesde: fechaInicio,
            fechaHasta: null,
            descripcion_id: Number(motivoId),
            descripcion: motivoSeleccionado?.descripcion || "",
            tipo: "AUSENCIA",
            comentario: comentarioDetalle || "",
          },
        };

        const calculo = await ApiSolicitudVacacionesService.calcular(empleado.empresaId, payload);
        const fechaHastaCalculada = calculo?.ausencia?.fechaHasta || "";
        if (!cancelled) {
          setFechaFin(fechaHastaCalculada);
        }
      } catch (error) {
        if (!cancelled) {
          setFechaFin("");
          showAppAlert("No se pudo calcular la fecha fin para dias habiles.", "warning");
        }
      } finally {
        if (!cancelled) {
          setIsCalculatingFechaHasta(false);
        }
      }
    };

    calcularFechaHastaHabiles();

    return () => {
      cancelled = true;
    };
  }, [
    usaDiasPermitidos,
    tipoComputoDiasMotivo,
    fechaInicio,
    motivoId,
    empleado.id,
    empleado.empresaId,
    comentarioDetalle,
    motivoSeleccionado?.descripcion,
    fechaHastaNaturalCalculada,
  ]);
  
 
  
  const handleSubmit = async (e) =>{
    e.preventDefault();
    if (tipo === "AUSENCIA" && !motivoId) {
      showAppAlert("Debe seleccionar un motivo de ausencia.", "warning");
      return;
    }

    if (usaDiasPermitidos && !fechaInicio) {
      showAppAlert("Debe indicar la fecha de inicio.", "warning");
      return;
    }

    if (usaDiasPermitidos && !fechaFin) {
      showAppAlert("No se pudo calcular una fecha de fin valida.", "warning");
      return;
    }

    const fechaHastaSolicitud = fechaFin;

    let json = {
        solicitud: {
            fechaSolicitud: dateUtils.formatDate(new Date()),
        },
        ausencia:{
            empleadoId: empleado.id,
            fechaDesde: fechaInicio,
            fechaHasta: fechaHastaSolicitud,
            tipo: tipo,
            descripcion_id: motivoId ? Number(motivoId) : null,
            descripcion: motivoSeleccionado?.descripcion || "",
            comentario: comentarioDetalle
        }

    }

    if (!usaDiasPermitidos && !json.ausencia.fechaHasta) {
      showAppAlert("Debe indicar una fecha de fin valida.", "warning");
      return;
    }

    if(tramitado){
      setTramitado(false)

    }
    const response = await ApiSolicitudVacacionesService.solicitar(empleado.empresaId, json)

      if(response.ok){

          setTramitado(true)
      }else{
          showAppAlert(`Ha ocurrido un error: ${response.status}`, "error");
      }

  }
  
  
  return (
    <>
        <Form onSubmit={handleSubmit}>
            <FormGroup >
                <Label className='mt-2'>Tipo</Label>
                <Input type='select' value={tipo} onChange={(e) =>setTipo(e.target.value)}>
                  <option value={"VACACIONES"}>Vacaciones</option>
                  <option value={"AUSENCIA"}>Ausencia</option>
                  <option value={"BAJA"}>Baja</option>
                </Input>

                {tipo === 'AUSENCIA' && (
                  <>
                    <Label for="motivoSelect" className='mt-3'>Motivo de Ausencia</Label>
                    <Input
                      type="select"
                      id="motivoSelect"
                      value={motivoId}
                      onChange={(e) => setMotivoId(e.target.value)}
                      required
                    >
                      <option value="">Seleccione un motivo</option>
                      {motivos.map((motivo) => (
                        <option key={motivo.id} value={motivo.id}>
                          {motivo.descripcion}
                          {Number.isInteger(motivo.diasPermitidos) && motivo.diasPermitidos > 0
                            ? ` (${motivo.diasPermitidos} dias ${motivo.tipoComputoDias === "NATURALES" ? "naturales" : "habiles"})`
                            : ""}
                        </option>
                      ))}
                    </Input>
                    {motivoSeleccionado ? (
                      <div className="mt-2">
                        <Badge color={tipoComputoDiasMotivo === "NATURALES" ? "dark" : "primary"}>
                          Computo: {tipoComputoLabel}
                        </Badge>
                      </div>
                    ) : null}

                    {motivoId && (
                      <>
                        <Label className='mt-2'>Detalle del motivo</Label>
                        <Input
                          type="text"
                          value={comentarioDetalle}
                          onChange={(e) => setComentarioDetalle(e.target.value)}
                          placeholder="Escriba observaciones de su ausencia"
                        />
                      </>
                    )}
                  </>
                )}

                <Label>Fecha inicio</Label>
                <Input type='date' value={fechaInicio} onChange={(e) =>setFechaInicio(e.target.value)} required></Input>

                <Label className='mt-2'>Fecha fin</Label>
                <Input
                  type='date'
                  value={fechaFin}
                  onChange={(e) =>setFechaFin(e.target.value)}
                  required={!usaDiasPermitidos}
                ></Input>
                {usaDiasPermitidos && tipoComputoDiasMotivo === "HABILES" ? (
                  <small className="text-muted d-block mt-2">
                    {isCalculatingFechaHasta
                      ? "Calculando fecha fin..."
                      : "Fecha fin calculada en base a dias habiles y festivos."}
                  </small>
                ) : null}
            </FormGroup>
            <Button color='success' type='submit' > Guardar </Button>

        </Form>
        <br></br>
        { tramitado ? (
          <UncontrolledAlert color="success" fade={false} >
          <span className="alert-inner--icon">
            <i className="ni ni-like-2" />
          </span>{" "}
          <span className="alert-inner--text">
            <strong>Tramitado</strong> Se ha tramitado correctamente
          </span>
        </UncontrolledAlert>
        ): ""

        }
        
    </>
  )
}

export default FormSolicitarVacaciones


